// apps/console/src/services/api/robot-alerts-merge.ts
//
// The pure row-merging rules robot-alerts-store.ts applies when folding a database read into what
// it holds. No module state; split out only to keep the store inside the 300-line rule.

import type { RobotAlertItem } from './robot-alerts-types'

/** Newest first, by presence recency where we have it. Mirrors the broker's own snapshot order. */
export function byRecency(a: RobotAlertItem, b: RobotAlertItem): number {
  const at = Date.parse(a.lastSeenAt ?? a.recordedAt ?? '')
  const bt = Date.parse(b.lastSeenAt ?? b.recordedAt ?? '')

  if (!Number.isFinite(at) || !Number.isFinite(bt)) return 0

  return bt - at
}

/** Copy only the keys the source actually defines, so a thinner row never blanks a richer one. */
export function overlayDefined(base: RobotAlertItem | undefined, next: RobotAlertItem): RobotAlertItem {
  if (!base) return next

  // Filter BEFORE spreading. A plain `{...base, ...next}` would let `next`'s explicitly-undefined
  // keys win and blank the very fields this exists to preserve — `name` above all.
  const defined = Object.fromEntries(Object.entries(next).filter(([, v]) => v !== undefined))

  return { ...base, ...defined }
}
